import React, {Component} from 'react';
import './language-switch.scss';
import {connect} from "react-redux";
import store from "../../../../store";
import {IntlActions, withTranslate} from 'react-redux-multilingual'

const LANGUAGES = [
    {code: 'am', short: 'Հայ', lang: 'hy'},
    {code: 'en', short: 'EN', lang: 'en'},
    {code: 'ru', short: 'РУ', lang: 'ru'},
];

class LanguageSwitchBlock extends Component {

    changeLanguage(lang) {
        store.dispatch(IntlActions.setLocale(lang))
    }

    render() {
        const {translate, locale} = this.props;
        return (
            <div className={`cpr-lang${this.props.block ? ' cpr-lang--block' : ''}`} role="group"
                 aria-label={translate('language')}>
                {LANGUAGES.map(l => (
                    <button key={l.code} type="button" lang={l.lang}
                            className={`cpr-lang__btn${locale === l.code ? ' is-active' : ''}`}
                            aria-pressed={locale === l.code}
                            aria-label={translate(l.code)}
                            onClick={() => this.changeLanguage(l.code)}>
                        {l.short}
                    </button>
                ))}
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        locale: state.Intl.locale
    }
}

export default connect(mapStateToProps)(withTranslate(LanguageSwitchBlock));
